export const OpenAnalyticsAgentCustomizePopupIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g opacity="0.5">
      <path d="M10 18L10 2" stroke="#05050D" strokeWidth="2" />
      <line x1="2" y1="9.65454" x2="18" y2="9.65454" stroke="#05050D" strokeWidth="2" />
    </g>
  </svg>
);
